module.exports = __webpack_public_path__ + "static/media/xb_logo.86c79b0f.jpg";